export default __webpack_public_path__ + "static/media/help-center.c5eb1a78.png";